export default __webpack_public_path__ + "static/media/close.609fc0d8.svg";